import { createFileRoute } from "@tanstack/react-router";
import { TenantsPage } from "@/features/admin/tenants-page";
import { ensureSuperAdminAccess } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/konfiguracja/organizacje")({
	beforeLoad: async () => {
		await ensureSuperAdminAccess();
	},
	component: TenantsPage,
});
